import React from 'react';
import useDimensions from 'hooks/useDimensions';
import useServerDown from 'hooks/useServerDown';
import { useZxing } from 'react-zxing';

type Props = {
	onScan: (code: string, serverIsDown: boolean) => void;
};

export const QRReader = ({ onScan }: Props) => {
	const isDown = useServerDown();

	const { height, width } = useDimensions();

	const { ref } = useZxing({
		onDecodeResult(result) {
			onScan(result.getText(), isDown);
		},
		constraints: {
			video: {
				aspectRatio: width / height,
				facingMode: 'environment',
				width: { ideal: 1920 },
				height: { ideal: 1080 },
			},
			audio: false,
		},
		timeBetweenDecodingAttempts: 500,
	});

	return (
		<div style={{ padding: 0, margin: 0, width: '100%', height: '100%', overflow: 'hidden', position: 'relative' }}>
			<video
				ref={ref as React.RefObject<HTMLVideoElement>}
				style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }}
			/>
		</div>
	);
};

export default QRReader;
